import React, { useState } from 'react';
import OnboardingLayout from '../components/OnboardingLayout/OnboardingLayout';
import StepHeader from '../components/StepHeader/StepHeader';
import { Button } from '../components/Button/Button';
import { Options, TypeCard, IconCircle, CardText, RadioDot } from './WelcomeStep.styles';

const TYPES = [
    { id: 'retail', icon: 'ri-store-2-line' },
    { id: 'wholesale', icon: 'ri-stack-line' },
    { id: 'both', icon: 'ri-scales-3-line' },
];

/**
 * Step 0 (welcome): the merchant picks the store type (retail / wholesale) and starts.
 * No progress bar — it is the entry screen. The choice drives the rest of the flow and the preview.
 */
const WelcomeStep = ({ ctx }) => {
    const { t, isDemo, draft, updateDraft, goTo, trackStep } = ctx;
    const [type, setType] = useState(draft.storeType || null);

    const choose = (id) => {
        setType(id);
        updateDraft({ storeType: id });
    };

    const start = () => {
        if (!type) return;
        updateDraft({ storeType: type });
        trackStep('signup_step_completed', { store_type: type });
        goTo('cuenta');
    };

    return (
        <OnboardingLayout
            preview={ctx.preview}
            step={0}
            stepKey="inicio"
            title={t('SignUpV2.inicio.title')}
            headingId="inicio-title"
            isDemo={isDemo}
            showLoginLink
            hideProgress
            footer={
                <Button onClick={start} iconRight="ri-arrow-right-line" disabled={!type}>
                    {t('SignUpV2.inicio.cta')}
                </Button>
            }
        >
            <StepHeader
                id="inicio-title"
                center
                title={t('SignUpV2.inicio.title')}
                subtitle={t('SignUpV2.inicio.subtitle')}
            />
            <Options role="radiogroup" aria-labelledby="inicio-title">
                {TYPES.map((option) => {
                    const selected = type === option.id;
                    return (
                        <TypeCard
                            key={option.id}
                            type="button"
                            role="radio"
                            aria-checked={selected}
                            selected={selected}
                            onClick={() => choose(option.id)}
                        >
                            <IconCircle selected={selected} aria-hidden="true">
                                <i className={option.icon} />
                            </IconCircle>
                            <CardText>
                                <strong>{t(`SignUpV2.inicio.${option.id}.title`)}</strong>
                                <span>{t(`SignUpV2.inicio.${option.id}.desc`)}</span>
                            </CardText>
                            <RadioDot selected={selected} aria-hidden="true" />
                        </TypeCard>
                    );
                })}
            </Options>
        </OnboardingLayout>
    );
};

export default WelcomeStep;
